import 'mapbox-gl/dist/mapbox-gl.css';

import { IControl } from 'mapbox-gl';
import React from 'react';
import ReactDOM from 'react-dom';

import DrawControlComponent from '../components/DrawControl';

class DrawControl implements IControl {
  private controlGroup: HTMLDivElement;

  constructor() {
    this.controlGroup = document.createElement('div');
    this.controlGroup.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
  }

  onAdd(map: mapboxgl.Map) {
    ReactDOM.render(
      <DrawControlComponent container={this.controlGroup} map={map} />,
      this.controlGroup
    );
    return this.controlGroup;
  }

  onRemove() {
    if (this.controlGroup.parentNode) {
      this.controlGroup.parentNode.removeChild(this.controlGroup);
    }
  }
}

export default DrawControl;
